import api from '../../config/http-common'

const buildQuery = (pagination) => {
  let query =
    '?pageNumber=' + pagination.page + '&pageSize=' + pagination.rowsPerPage
  return query
}

const createIssueType = (payload) => {
  return api.securedAxios().post('/web/v4/prism/issue-type', payload)
}

const getCategories = () => {
  return api.securedAxios().get('/web/v4/prism/categories')
}

const filterPropertyMgmt = (payload) => {
  return api
    .securedAxios()
    .post(
      '/web/v4/prism/property-management/list' + buildQuery(payload),
      payload,
    )
}

const propertyList = () => {
  return api.securedAxios().get('/web/v4/prism/buildings');
}

const getIssueTypes = () => {
  return api.securedAxios().post('/web/v4/prism/issue-types/list')
}

const validateCredentials = (payload) => {
  return api.securedAxios().post('/web/v4/prism/authenticate' , payload)
}

const prismIntegrationService = {
  createIssueType,
  getCategories,
  filterPropertyMgmt,
  propertyList,
  getIssueTypes,
  validateCredentials
}

export default prismIntegrationService
